const tools = 
[
    {
        name:'Reacjts',
        color:''
    },
    {
        name:'Rails',
        color:''
    },
    {
        name:'Docker',
        color:''
    },
    {
        name:'Django',
        color:''
    },
    {
        name:'Xamarin',
        color:''
    },
    {
        name:'Azure Active Directory',
        color:''
    },
    {
        name:'B2C AAD',
        color:''
    },
    {
        name:'Selenium',
        color:''
    }
]

const projects = 
[
    {
        name:'Arnote',
        banner:'ANT',
        summary:'A social platform, where artist can create live drawing sessions for themselves and friends, to join and draw together in real time.',
        time:'2021',
        member:'Individual',
        tools:[tools[0],tools[1],tools[2],tools[3],tools[4],tools[7]],
        git:'https://github.com/DuyNguyen19993010/Final-Year-project-Realtime-drawng-app'
    },
    {
        name:'Multi-tenant Microsoft Learn LTI',
        banner:'LTI',
        summary:'Improve Microsoft Learn LTI to allow universities to share the same content via different Learning Management System',
        time:'2022',
        member:'6',
        tools:[tools[0],tools[5],tools[6],tools[7]],
        git:'https://github.com/UCL-MSc-Learn-LTI/Learn-LTI'
    },
    {
        name:'Performance AI',
        banner:'PAI',
        summary:'Improve Microsoft Performance AI app to help prepare visually impaired people to compete fairly in bicycle races. The app uses AI to suitable cycling exercise plans and intelligently guide the user through these exercise with audio signal.',
        time:'2022',
        member:'6',
        tools:[tools[4]],
        git:'https://www.youtube.com/watch?v=8KFRf7oIAbE '
    },
    {
        name:'FakeNews',
        banner:'FNW',
        summary:'A newspaper website that allows author to create and post articles and blogs. Users can sign up and interact with the posts such as liking, commenting on the posts.',
        time:'2020',
        member:'3',
        tools:[tools[3],tools[7]],
        git:'https://github.com/tobywynne-mellor/newspaper-app'
    }

]

export default projects;